'use client';

import { HeadPhoneIcon, MenuIcon, NotificationIcon } from '@insta-club/components';
import { useDrawerStore, useSessionStore } from '@insta-club/state';
import { capitalizeFirstLetter, truncateText } from '@insta-club/utilities';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { initWebPushNotifications } from 'src/libs/config/firebase';
import { useAccountSwitcherSheetStore } from 'src/libs/state/stores/accountSwitcherSheet';

export default function Navbar() {
    const pathName = usePathname();
    const unreadAlerts = useSessionStore((state) => state.unread_alerts);
    const unreadTickets = useSessionStore((state) => state.session?.unread_tickets);

    const includedPaths = ['/dashboard', '/analysis', '/explore', '/academy', '/profile'];
    const isIncludedPaths = includedPaths.includes(pathName);
    const { openDrawer } = useDrawerStore();
    const accountSwitcherSheetOpen = useAccountSwitcherSheetStore((state) => state.openDrawer);
    const activePageSession = useSessionStore((state) => state.page);

    useEffect(() => {
        if (!isIncludedPaths) return;
        async function webPush() {
            try {
                await initWebPushNotifications();
            } catch (err) {
                console.log(err);
            }
        }
        webPush();
    }, [isIncludedPaths]);

    if (!isIncludedPaths) return null;

    return (
        <div className='fixed top-0 z-[39] w-full max-w-[var(--container-max)] bg-white/60 backdrop-blur-md'>
            <div className='flex h-full w-full items-center justify-between px-6 py-3'>
                <button onClick={openDrawer} className='cursor-pointer'>
                    <MenuIcon />
                </button>
                {['/profile'].includes(pathName) ? (
                    <div
                        className='flex cursor-pointer space-x-1.5 rounded-full bg-gray-100 px-2.5 py-2'
                        onClick={() => {
                            accountSwitcherSheetOpen();
                        }}
                    >
                        <div className='flex gap-1.5'>
                            <svg
                                width='16'
                                height='16'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M17.9197 8.17993H11.6897H6.07975C5.11975 8.17993 4.63975 9.33993 5.31975 10.0199L10.4997 15.1999C11.3297 16.0299 12.6797 16.0299 13.5097 15.1999L15.4797 13.2299L18.6897 10.0199C19.3597 9.33993 18.8797 8.17993 17.9197 8.17993Z'
                                    fill='#292D32'
                                />
                            </svg>

                            <h6 className='h-[16px] text-base leading-[1.3] font-bold text-gray-700'>
                                {truncateText(capitalizeFirstLetter(activePageSession?.page ?? ''), 15)}
                            </h6>
                        </div>
                    </div>
                ) : (
                    <div className='flex items-center gap-4'>
                        <Link href={'/support'} className='relative leading-0'>
                            {(unreadTickets ?? 0 > 0) ? (
                                <div className='bg-secondary-500 absolute -top-[5px] -right-[5px] h-2 w-2 rounded-full' />
                            ) : null}
                            <button className='cursor-pointer'>
                                <HeadPhoneIcon />
                            </button>
                        </Link>
                        <Link href='/notifications' className='relative leading-0'>
                            {unreadAlerts > 0 ? (
                                <div className='bg-secondary-500 absolute -top-[5px] right-0 h-2 w-2 rounded-full' />
                            ) : null}
                            <button className='cursor-pointer'>
                                <NotificationIcon />
                            </button>
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}

